import { ThemeProvider } from '@material-ui/core/styles';
import clsx from 'clsx';
import { useSelector } from 'react-redux';

const FusePageSimpleSidebarContent = ({ classes, header, content, variant, sidebarInner }) => {
	const mainThemeDark = useSelector(({ fuse }) => fuse.settings.mainThemeDark);

	return (
		<>
			{header ? (
				<ThemeProvider theme={mainThemeDark}>
					<div className={clsx(classes.sidebarHeader, variant, sidebarInner && classes.sidebarHeaderInnerSidebar)}>
						{header}
					</div>
				</ThemeProvider>
			) : null}

			{content ? <div className={classes.sidebarContent}>{content}</div> : null}
		</>
	);
};

export default FusePageSimpleSidebarContent;
